// extracted by mini-css-extract-plugin
export default {"resendButton":"verify-code-form_resendButton__a4VaH","resendProgress":"verify-code-form_resendProgress__lzvlo"};